/**
 * Shared constants used by browser notification services.
 * Keeping literals here avoids duplicated "magic strings" across classes.
 */
export namespace BrowserNtf {
  export const DEFAULT_DEDUPE_MS = 30_000;
  export const SW_PATH = '/push-notification-sw.js';
  export const ESTATE_QUERY_KEY = 'ntfEstateId';
  export const COMPANY_QUERY_KEY = 'ntfCompanyId';
  export const PUSH_SUBSCRIPTION_COLLECTION = 'webPushSubscription/$userId';
  export const SUBSCRIPTION_OBJECT = 'browserNtfSubscription/$userId';

  export const SW_MESSAGE_EVENT = 'message';
  export const SW_EVENT_CLICK = 'FLIKO_NOTIFICATION_CLICK';
  export const SW_EVENT_PUSH = 'FLIKO_NOTIFICATION_PUSH';

  export const TOAST_DURATION_MS = 60_000;
  export const TOAST_HORIZONTAL_POSITION = 'right';
  export const TOAST_VERTICAL_POSITION = 'bottom';
  export const TOAST_PANEL_CLASS = 'browser-ntf-toast-panel';

  export const POPUP_TARGET = '_blank';

  export const MSG_UNSUPPORTED = 'browserNtf.unsupported';
  export const MSG_PERMISSION_GRANTED = 'browserNtf.permissionGranted';
  export const MSG_PERMISSION_DISABLED = 'browserNtf.permissionDisabled';
  export const MSG_PERMISSION_DENIED = 'browserNtf.permissionDenied';
}
